export const userContinuesFromRecommendedPlan = (
  email,
  selectedMealPrepType,
  selectedFreshRecipes,
  selectedBakedRecipes,
  breeds,
) => {
  const dryRecipeCount = selectedBakedRecipes?.length || 0;
  const freshRecipeCount = selectedFreshRecipes?.length || 0;
  return {
    type: 'User continues from recommended plan',
    data: {
      customer_info: {
        email: email,
      },
      meal_prep_type: selectedMealPrepType,
      recipes_count: { dry: dryRecipeCount, fresh: freshRecipeCount },
      recipes_selected: {
        dry: selectedBakedRecipes,
        fresh: selectedFreshRecipes,
      },
      breeds: breeds,
    },
  };
};

export const recipeSelected = recipe => ({
  type: 'Recipe Selected',
  data: {
    recipe,
  },
});

export const recipeUnselected = recipe => ({
  type: 'Recipe Unselected',
  data: {
    recipe,
  },
});

export const userExpandsFreshRecipeDetails = recipe => ({
  type: 'User expands fresh recipe details',
  data: {
    recipe,
  },
});

export const userExpandsMealPlanDetails = () => ({
  type: 'User Expands Meal Plan Details',
});

export const userExpandsCollapsibleMenu = () => ({
  type: 'User Expands Recipe Menu',
});

export const mealPlanTypeSelected = mealPlanType => ({
  type: 'Meal Plan Type Selected',
  data: {
    mealPlanType,
  },
});
